module.exports = __webpack_public_path__ + "img/dailycheck.8403f050.png";